module.exports = __webpack_public_path__ + "static/IMG_2712-85b474c2d4b60d92a48ba06e30cf9ca0.jpg";